/**
 * „Kritzl liest deinen Text" — a strip at the bottom edge, nothing more.
 *
 * It was a dialog over the whole screen first, with a way to step aside.
 * Both were wrong. There is nothing to decide here: the reading takes a few
 * seconds, it runs whether or not anybody watches, and stopping it would
 * only throw away an answer already paid for. A screen one has to get rid of
 * is a screen that should not have been there.
 *
 * So it sits at the bottom, out of the way, and says what is happening while
 * it happens. The app stays usable — whoever wants to practise now practises
 * with what is already there, and the new exercises turn up when they are
 * ready.
 *
 * The same barber pole as the photograph, only quieter: nobody knows how long
 * it takes, and a bar that fills at a guessed pace lies. Measured on his own
 * texts: a short one 2.9 seconds, a whole page 14.
 */

export function Reviewing() {
  return (
    <div class="reviewing" role="status" aria-live="polite">
      <span class="reviewing-pole" aria-hidden="true" />
      {/* „deinen Text", not the title. The title of a text is its first
          line, which on an unfinished one is a sentence — and a sentence in
          here makes the strip a paragraph. Which text it is hardly matters:
          it is the one just written. */}
      <span class="reviewing-text">Kritzl liest deinen Text …</span>
    </div>
  )
}
